<template>
  <div class="main">
    <back title="新闻中心"></back>
    <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/banner/news-banner.jpg">
      <template v-slot:loading>
        <van-loading size="30" color="#fff" />
      </template>
    </van-image>
    <van-tabs v-model="active" @click="click" color="#aa6b01" title-active-color="#aa6b01">
      <van-tab title="学校新闻">
        <!-- <div class="top">
          <RadioGroup v-model="button1" type="button">
            <Radio label="最新"></Radio>
            <Radio label="最热"></Radio>
          </RadioGroup>
        </div>-->
        <div class="one" v-for="data in datas" :key="data.id" v-on:click="to(data.id)">
          <div class="one-left">
            <img :src="data.cover_url" />
          </div>
          <div class="one-right">
            <div class="title">{{ data.title }}</div>
            <div class="info">{{ data.author }}</div>
            <div class="info" style="text-align:left">
              {{ data.create_time }}
              <span>{{ data.click }}次阅读</span>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="行业新闻">
        <!-- <div class="top">
          <RadioGroup v-model="button1" type="button">
            <Radio label="最新"></Radio>
            <Radio label="最热"></Radio>
          </RadioGroup>
        </div>-->
        <div class="one" v-for="data in datas" :key="data.id" v-on:click="to(data.id)">
          <div class="one-left">
            <img :src="data.cover_url" />
          </div>
          <div class="one-right">
            <div class="title">{{ data.title }}</div>
             <div class="info">{{ data.author }}</div>
            <div class="info" style="text-align:left">
              {{ data.create_time }}
              <span>{{ data.click }}次阅读</span>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="学生风采">
        <!-- <div class="top">
          <RadioGroup v-model="button1" type="button">
            <Radio label="最新"></Radio>
            <Radio label="最热"></Radio>
          </RadioGroup>
        </div>-->
        <div class="one" v-for="(data, key) in datas" :key="key" v-on:click="to(data.id)">
          <div class="one-left">
            <img :src="data.cover_url" />
          </div>
          <div class="one-right">
            <div class="title">{{ data.title }}</div>
             <div class="info">{{ data.author }}</div>
            <div class="info" style="text-align:left">
              {{ data.create_time }}
              <span>{{ data.click }}次阅读</span>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="入学答疑">
        <!-- <div class="top">
          <RadioGroup v-model="button1" type="button">
            <Radio label="最新"></Radio>
            <Radio label="最热"></Radio>
          </RadioGroup>
        </div>-->

        <div class="one" v-for="(data, key) in datas" :key="key" v-on:click="to(data.id)">
          <div class="one-left">
            <img :src="data.cover_url" />
          </div>
          <div class="one-right">
            <div class="title">{{ data.title }}</div>
            <div class="info">{{ data.author }}</div>
            <div class="info" style="text-align:left">
              {{ data.create_time }}
              <span>{{ data.click }}次阅读</span>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="content"></div>
    <allMenu></allMenu>
  </div>
</template>
<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      datas: [],
      button1: "最新"
    };
  },
  components: {
    back: () => import("../../../components/head/back"),
    allMenu: () => import("@/components/menu/allMenu")
  },
  methods: {
    getlist(index) {
      this.$axios
        // .get("http://localhost/index.php/wap/articlelist", {
          .get("http://api.cdomick.com/index.php/wap/articlelist", {
          params: {
            index: index + 1
          }
        })
        .then(response => {
          this.datas = response.data.data;
        });
    },
    click(index) {
      // console.log(index);
      this.getlist(index);
    },
    to(id) {
      this.$router.push({ path: `/detail/${id}` });
    }
  },
  mounted() {
    this.getlist(0);
  }
};
</script>
<style lang="less" scoped>
/deep/ .van-tab span {
  font-size: 17px;
  font-weight: 600;
}
// /deep/ .ivu-radio-group-button .ivu-radio-wrapper-checked{
//   color:#a96b04;
//   border-color:#a96b04;
// }
.main {
  margin-top: 50px;
}
.top {
  width: 100%;
  padding: 15px 15px 0px 15px;
}
.one {
  width: 100%;
  padding: 15px;
  background: #fff;
  border-bottom: 1px solid #eee;
  display: flex;
}
.one-left {
  width: 40%;
  height: 100px;
  background: #eee;
  margin-right: 2%;
}
.one-left img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.one-right {
  width: 58%;
  height: 100px;
}
.title {
  width: 100%;
  height: 60px;
  font-size: 14px;
  font-weight: 600;
}
.info {
  width: 100%;
  height: 20px;
  font-size: 12px;
  line-height: 30px;
}
.info span {
  float: right;
}
.banner {
  width: 100%;
  height: 204px;
  position: relative;
}
.banner-button {
  width: 70%;
  position: absolute;
  margin-top: 15px;
  line-height: 28px;
  bottom: 12px;
  left: 15%;
  color: #fff;
  height: 38px;
  background: rgb(0, 0, 0, 0.2);
  border: 1px solid #fff;
}
.content {
  padding: 1px 16px 16px 16px;
}
</style>
